import PrizeLandingPage from 'components/prize-landing-pages/PrizeLandingPage';
import MainLayout from 'components/layout/MainLayout';
import { ASSET_PREFIX } from 'utils/constants';
import GreenPageSection from 'components/GreenPageSection';
import Subheading from 'components/Subheading';
import RoundedButton from 'components/RoundedButton';
import ImageWithContentSection from 'components/prize-landing-pages/ImageWithContentSection';
import React from 'react';
import { scrollToSection } from 'utils/common';
import WinnerContentSection from 'components/prize-landing-pages/WinnerContentSection';
import { NextSeo } from 'next-seo';
import HowItWorksAndChoosePlanSection
  from 'components/prize-landing-pages/HowItWorksAndChoosePlanSection';

const WinTheWeddingOfYourDreams = () => {
  const imageDirectory = `${ASSET_PREFIX}/images/prize-landing-pages/win-the-wedding-of-your-dreams`;

  const handleScrollToEntryMethodCards = () => {
    scrollToSection('#howItWorksAndChoosePlanSection');
  };

  return (
    <MainLayout paddedMaxWidthContainer={false}>
      <NextSeo
        title="DAYMADE | Win The Wedding Of Your Dreams Worth £100k"
        description="Enter our weekly draw for the chance to win the wedding of your dreams & all-paid-for stag/hen do!"
        canonical="https://www.daymade.co.uk/prizes/details/win-a-wedding"
        openGraph={{
          title: 'DAYMADE | Win The Wedding Of Your Dreams Worth £100k',
          description: 'Enter our weekly draw for the chance to win the wedding of your dreams & all-paid-for stag/hen do!',
        }}
      />

      <div id="top-of-page" />

      <PrizeLandingPage>
        <img
          src={`${imageDirectory}/hero.png`}
          className='hero'
          alt="newlyweds walking down aisle while confetti is thrown above them"
        />

        <GreenPageSection additionalClassName='pageTitleGreenSectionContainer'>
          <Subheading Tag='h1' className='pageTitle'>
            Win The Wedding Of Your Dreams<br />
            <span style={{ fontSize: '2.5em', display: 'block' }}>
              Worth&nbsp;<strong>£100k</strong>
            </span>
          </Subheading>
          <p>
            Enter our weekly draw for the chance to win the wedding of your dreams & all-paid-for stag/hen do!
          </p>
          <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
            Enter Now
          </RoundedButton>
          <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', margin: '3em 1em 0', width: '100%', maxWidth: 450 }}>
            <a href='https://uk.trustpilot.com/review/daymade.co.uk' target='_blank' style={{ margin: '0 0 2em 0', width: '35%' }}>
              <img src={`${ASSET_PREFIX}/images/play-free-lp/trustpilot-logo-grey.svg`} style={{ width: '100%' }} />
            </a>
            <a href='https://www.veritree.com/' target='_blank' style={{ margin: '0 0 2em 0', width: '50%', display: 'flex', alignItems: 'center', textAlign: 'left', wordBreak: 'break-word', whiteSpace: 'break-spaces' }}>
              <img src={`${ASSET_PREFIX}/images/veritree-logo-dark.svg`} style={{ width: '25%', marginRight: '0.5em' }} />
              Plant a tree with every purchase
            </a>
          </div>
        </GreenPageSection>

        <ImageWithContentSection
          subheadingText={<>Could You Be The Next <strong>Winner?</strong></>}
          imageSrc={`${imageDirectory}/secondary1.png`}
          imageAltText="couple getting married surrounded by sparklers at night"
        >
          <p>
            "I can't see me lovin' nobody but you, for all my liiiiiife". This one is for the lovebirds who cannot wait to tie the knot! DAYMADE gives you this incredible chance to WIN the most beautiful day of your life.
          </p>

          <p>
            With this DAYMAKERboost prize, you, your other half and your very own wedding planner will get £100,000 to spend on the wedding of your dreams. Everything that makes a wedding a wedding will be included (catering, venue hire, outfits, photography, entertainment - the whole shebang!) but to make it even more epic: we'll throw in an all paid-for stag/hen do as well as an unforgettable honeymoon.
          </p>

          <p>
            So, a dream wedding without breaking the bank and dealing with the wedding-prep stress? YES, I DO!!
          </p>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <ImageWithContentSection
          subheadingText={<>What's <strong>Included?</strong></>}
          imageSrc={`${imageDirectory}/secondary2.png`}
          imageAltText="couple kissing with sparklers surrounding them"
          reverseDesktopDirection
        >
          <ul style={{ fontWeight: 600 }}>
            <li>Wedding planner</li>
            <li>Venue hire</li>
            <li>Wedding dress</li>
            <li>Photography</li>
            <li>Groom’s attire</li>
            <li>Catering (food and drink)</li>
            <li>Bridal hair and makeup</li>
            <li>Entertainment</li>
            <li>Wedding cake</li>
            <li>Transport</li>
            <li>Invitations</li>
            <li>Decor & details</li>
          </ul>

          <p>
            Also:
          </p>
          <ul style={{ fontWeight: 600 }}>
            <li>Stag & hen do weekend for up to 6 people (several European cities offered)</li>
            <li>1-week honeymoon</li>
          </ul>

          <p style={{ fontStyle: 'italic', fontSize: '0.9em'}}>
            * Up to a total value of £100,000
          </p>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-1.png`}
          style={{
            width: '100%',
          }}
        />

        <WinnerContentSection
          onCtaClick={handleScrollToEntryMethodCards}
        />

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-2.png`}
          style={{
            width: '100%',
          }}
        />

        <HowItWorksAndChoosePlanSection />
      </PrizeLandingPage>

      <style jsx>
        {`
          :global(.pageTitleGreenSectionContainer .pageTitle) {
            font-size: 2em;
          }
          
          @media(max-width: 500px) {
            :global(.pageTitleGreenSectionContainer .pageTitle) {
              font-size: 1.3em;
            }
          }
        `}
      </style>
    </MainLayout>
  );
};

export default WinTheWeddingOfYourDreams;
